<template>
  <v-sheet id="scrolling-techniques-5" :height="$store.state.sys.fillHeight" class="overflow-y-auto">
    <v-container class="top-bg">
      <div style="height: 128px;"></div>
      <div v-if="$route.query.type='qq'">
        <v-row>
          <v-col>
            <h2>
              服务使用协议
            </h2>
            <v-card hover>
              <v-card-text>
                当您使用本网站服务时
                <br>1.禁止发送涉黄、涉政、涉恐、辱骂、威胁、广告等违规内容，后台已接入文字/图片识别系统，检测到违规内容后(可能会误伤)封禁账户。如果涉及到法律责任，相关内容将被上报至有关部门。
                <br>2.使用本站服务即默认同意本网站平台机器人账号有通过平台API功能被动向你推送消息的权利 。
                <br>3.使用本站服务即默认同意本网站保留有对你在本网站账号的所有管理权利。
                <br>4.使用本站服务即默认同意本网站保留机器人账号的所有管理权利。若您长时间未使用，您与机器人的好友状态可能会被机器人删除。
                <br>5.平台不会主动向你推送消息、你的一切活动均为主观操作、与平台无关。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>
              QQ私聊消息使用步骤简述 </h2>
            <v-card hover>
              <v-card-text>
                1.进入任性推控制台。
                <br>2.选择要使用的机器人。
                <br>3.把你添加的要接收消息的QQ号加你选择的机器人为好友（你不加机器人好友，机器人怎么给你发消息）。
                <br>4.调用接口，实现机器人给你的QQ发消息。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>
              QQ群消息使用步骤简述
            </h2>
            <v-card hover>
              <v-card-text>
                1. 在任性推控制台内申请QQ群白名单。<br>
                2. 根据现行政策系统审核通过或失败。<br>
                3. 邀请机器人入群后开始使用。（群消息推送功能需要申请开通，没有开通的话机器人会拒绝进群的！）
                <br>
                再或者：去Github获取最新后端自行私有化搭建。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>
              接口地址
            </h2>
            <v-card hover>
              <v-card-text>
                <strong>消息推送接口：{{ $store.state.sys.hostname }}/api/msg/send/您的KEY</strong>
                <br><br>您的KEY可在控制台查看。
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>
              请求方式
            </h2>
            <v-card hover>
              <v-card-text>
                POST，Content-Type：application/json。不懂？不懂百度学去
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>
              必填参数
            </h2>
            <v-card hover>
              <v-card-text>
                <h3>JSON格式对象:</h3><br>
                <pre v-highlight v-text="msg"><code></code></pre>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>
              QQ消息内容增强
            </h2>
            <v-card hover>
              <v-card-text>
                消息内容增强支持 QQ表情，群@，图片。
                详见<a class="link"
                       target="_blank"
                       href="https://napneko.github.io/zh-CN/develop/msg">NapCatQQ消息格式支持情况</a>、
                <a class="link"
                   target="_blank"
                   href="https://docs.go-cqhttp.org/cqcode/#%E8%BD%AC%E4%B9%89">CQ码文档</a><br>
                目前公有机器人不允许record video xml json cardimage等消息类型。
                <ul>
                  <li>
                    <span style="font-weight: bold;">表情用法：</span>
                    <ul>
                      <li>直接使用Emoji表情：🙂</li>
                      <li>
                        QQ原生表情：<span style="color: #1E9FFF;">[CQ:face,id=123]</span><br>
                        <span style="font-weight: bold;">例：</span>content="你好啊[CQ:face,id=123]这是一个表情。更多表情ID
                        <a class="link"
                           href="https://github.com/richardchien/coolq-http-api/wiki/%E8%A1%A8%E6%83%85-CQ-%E7%A0%81-ID-%E8%A1%A8"
                           target="_blank">点击这里</a>查看(不全)<br>
                        <span style="font-weight: bold;">注意：</span>如果使用了不存在的表情ID，那么本次推送的整条消息将不会被发送出去<br>
                      </li>
                    </ul>

                  </li>
                  <br>
<!--                  <li>-->
<!--                    <span style="font-weight: bold;">群@用法：</span>-->
<!--                    @个人 <span style="color: #1E9FFF;">[mirai:at:$target]</span>、-->
<!--                    @全体 <span style="color: #1E9FFF;">[mirai:atall]</span><br>-->
<!--                    <span style="font-weight: bold;">例：</span>msg=你好[mirai:at:1277489864]，我@了你。<br>-->
<!--                    <span style="font-weight: bold;">注意：</span>如果你@的QQ号不在群内或者非管理员使用了@全体，那么本次推送的整条消息将不会被发送出去，@语法仅在推送群消息时有效。-->
<!--                  </li>-->
<!--                  <br>-->
<!--                  <li>-->
<!--                    <span style="font-weight: bold;">图片用法：</span><span-->
<!--                      style="color: #1E9FFF;">[mirai:image:可访问的图片url地址]</span><br>-->
<!--                    <span style="font-weight: bold;">例：</span>content="你好，这是百度的logo图片[mirai:image:https://baidu.com/tupian.png]"<br>-->
<!--                    <span style="font-weight: bold;">注意：</span>图片格式包括[gif,png,bmp,jpg]，图片将经过任性推NSFW安全系统检测。若发送违规内容，您可能会受到警告或被封禁帐号。"-->

<!--                  </li>-->
                </ul>
                <br>
                <span style="font-weight:bold;">欢迎加QQ群：807374699进行讨论。</span>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>
              触发关键词回调功能
            </h2>
            <v-card hover>
              <v-card-text>
                在群里或者私聊中，机器人接收到的聊天消息<b>包含</b>您设置的聊天关键词，则机器人会向您设置的触发关键词回调URL发送一个POST请求，
                您可以在接收到该POST请求后做任何业务逻辑。聊天关键词和触发关键词回调URL可以在控制台设置。<br>
                <b>注意：请将回调页的HTTP状态码设置为200，否则将视为回调失败，机器人会进行3次重试操作。</b>
                <ul>
                  <li>
                    请求方式：POST，Content-Type=application/json
                  </li>
                  <br/>
                  <li>
                    Body：
                    <pre v-highlight v-text="callbackData"><code class="json"></code></pre>
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        咕咕咕。。已做技术实现，请前往控制台自行摸索
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: "Docs",
  data: () => ({
    msg: {
      content: "消息内容",
      meta: {
        type: "qq或qq_group",
        data: "接收人/群号码"
      }
    },
    callbackData: {
      id: "触发关键词ID",
      uid: "站内所属用户ID",
      appType: "app类型，如：qq",
      keyword: "包含关键词的完整消息",
      callbackURL: "回调URL",
      sender: "发送人号码",
      group: "触发消息如在群内则为群号码，否则为空",
      reply: "控制台设置的是否回复",
      response: "如reply为true，则response为回复内容"
    }
  })
}
</script>

<style scoped>

</style>
